import {
  Grid,
  Typography,
  WithStyles,
  withStyles,
  CardActions,
} from "@material-ui/core";
import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { dialogTopNav } from "../styles/dialogTopNav";
import CloseIcon from '@material-ui/icons/Close';
import { PriorityTitle, PriorityColors, Priority } from "../types/Constants";
import { getIconBasedOnPriority } from "../helpers/createContentRequest";
interface data {
  icon?: string,
  label?: string,
  subLabel?: string,
  color?: string
}

let dTopNavContent: Array<any> = [
  {
    icon: "/assets/svg/contentRequest/priority.svg",
    label: "Priority",
    subLabel: "Important but not urgent",
    color: "blue"
  },
  {
    icon: "/assets/svg/contentRequest/deadline.svg",
    label: "Deadline",
    subLabel: "11th Nov 2020",
    color: "blue"
  },
  {
    icon: "/assets/svg/contentRequest/goal.svg",
    label: "Goal",
    subLabel: "JEE Mains",
    color: "blue"
  },
  {
    icon: "/assets/svg/contentRequest/subject.svg",
    label: "Subject",
    subLabel: "Physics",
    color: "blue"
  },
  {
    icon: "/assets/svg/contentRequest/content-request-for.svg",
    label: "Content Request for"
  },
  {
    label: "Assigned by",
    subLabel: "JK Rai",
  },
  {
    icon: "/assets/svg/contentRequest/owner.svg",
    label: 'Request Owners',
    sublabel:'Request Owners'
  },
  {
    label:'Status',
    sublabel: 'Status'
  }
]

interface DialogTopNavProps extends WithStyles<typeof dialogTopNav> {
  classes: any,
  topNavValue: any
}
interface DialogTopNavState {
  content: Array<any>
}
class DialogTopNav extends Component<DialogTopNavProps, DialogTopNavState> {
  constructor(props: DialogTopNavProps) {
    super(props);
    this.state={
      content: dTopNavContent
    }
  }
  getSubLabelColor(subLabel: string) {
   switch(subLabel) {
     
     case Priority.importantAndUrgent:
     case PriorityTitle.importantAndUrgent: return PriorityColors.importantUrgent
     case Priority.notImportantButUrgent:
     case PriorityTitle.notImportantButUrgent: return PriorityColors.notImportantButUrgent
     case Priority.importantButNotUrgent:
     case PriorityTitle.importantButNotUrgent: return PriorityColors.importantNotUrgent
     case Priority.notImportantAndNotUrgent:
     case PriorityTitle.notImportantAndNotUrgent: return PriorityColors.notImportantNotUrgent

   }
  }
  render() {
    const { classes, topNavValue } = this.props;
    const { content } = this.state
    let ContentLength= topNavValue &&  Object.keys(topNavValue).length;
    return (
      <>
        <Grid container justify="flex-start" alignItems="center"
          spacing={16}
          className={classes.navBar}>
          {            
            content.map((value: any) => {
              if(value && topNavValue && !Object.keys(topNavValue).includes(value.label)) {
                return null;
              }
              return <>
                <Grid item>
                  
                    <Grid container alignItems="center">
                        {topNavValue && value && value.label !== "Priority" && Object.keys(topNavValue).includes(value.label) && 
                        <Grid item>
                          <img src={value.icon} />
                            &nbsp;&nbsp;
                        </Grid>}
                        {topNavValue && value && value.label === "Priority" && Object.keys(topNavValue).includes(value.label) && 
                        <Grid item>
                          <img src={getIconBasedOnPriority(topNavValue[value.label])} />
                            &nbsp;&nbsp;
                        </Grid>}                  
                            { topNavValue &&  Object.keys(topNavValue).includes(value.label) &&
                              <Grid item>
                                <><span className={[value.label.split(' ').join('_'), "label"].join(' ')}>{value.label}:&nbsp;</span>
                                <span className={[`${this.getSubLabelColor(topNavValue && topNavValue[value.label])} subLabel`, 
                                value.label==='Assigned by' && "colorGray",
                                (value.label != 'Request Owners' && ContentLength === 5) ? "textEllipse" :
                                (value.label==='Request Owners' && ContentLength < 5) && 'textEllipse'].join(' ')}>
                                  {topNavValue && topNavValue[value.label] ? topNavValue[value.label]:'N/A'}
                                  </span>
                                </>
                              </Grid>
                            }
                        
                      </Grid>
                    
                </Grid>
              </>
            })
          }
        </Grid>
      </>
    );
  }
}

// @ts-ignore
export default connect()(withStyles(dialogTopNav)(DialogTopNav));
